import { Controller } from "@hotwired/stimulus"

// Stimulus controller to toggle password visibility
export default class extends Controller {
  static targets = ["input", "toggle"]

  connect() {
    // Set initial button text
    this.toggleTarget.innerHTML = this.inputTarget.type === "password" ? "<i class='fa fa-eye fa-fw'></i>" : "<i class='fa fa-eye-slash fa-fw'></i>";
  }

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
      this.toggleTarget.innerHTML = "<i class='fa fa-eye-slash fa-fw'></i>"
    } else {
      this.inputTarget.type = "password"
      this.toggleTarget.innerHTML = "<i class='fa fa-eye fa-fw'></i>"
    }
  }
}
